(function () {
	const tickSlider = () => {
		$(".ticker").each(function () {
			const $this = $(this);
			const id = $this.attr("id");
			const tickerId = $this.data("ticker-id");
			const tickerSpeed = $this.data("ticker-speed") * 1000;
			const tickerSwiper = new Swiper(`#${id} .ticker-js-${tickerId}`, {
				slidesPerView: 3,
				loop: true,
				 watchOverflow: true,
				centeredSlides: true,
				loopAdditionalSlides: 8,
				spaceBetween: 20,
				pagination: {
					el: ".swiper-pagination",
					clickable: true
				},
				speed: 5000,
				autoplay: {
					delay: 0,
					enabled: true,
				}
			});
		});
	};
	document.addEventListener("shopify:section:load", function () {
		setTimeout(() => {
			tickSlider();
		}, 100);
	});
	setTimeout(() => {
		tickSlider();
	}, 100);
})();
